import { TextFieldProps, TextField as MuiTextField } from "@mui/material";
import { get } from "lodash";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

type IFormTextInputProps = {
  name: string;
  label: string;
} & TextFieldProps;

/**
 * Custom text TextField for app forms
 * 
 * @param {string} name - Field name
 * @param {string} label - Text field label
 * @param {string} helperText - Text field helper text
 * @param {TextFieldProps} otherProps - Other props from MUI TextField
 * 
 */

export const TextField: FC<IFormTextInputProps> = ({ name, label, helperText, ...otherProps }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      render={({ field }) => (
        <MuiTextField
        {...field}
          fullWidth
          label= {label}
          error={!!errors[name]}
          {...otherProps}
          helperText={get(errors, name) ? (get(errors, `${name}.message`) as unknown as string) : helperText}
        />
      )}
    />
  );
};